export default __webpack_public_path__ + "static/media/Visa.c22bd5e1.svg";